import { useEffect, useState } from '@wordpress/element';

function decodeText(value) {
    if (!value) return '';

    if (typeof document === 'undefined') {
        return String(value)
            .replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'");
    }

    const textarea = document.createElement('textarea');
    textarea.innerHTML = String(value);
    return textarea.value;
}

async function fetchPartners(mode) {
    const restUrl = window.bajantubeMusic?.restUrl || '/wp-json/bajantube/v1';
    const response = await fetch(`${restUrl}/giveaway/partners?mode=${encodeURIComponent(mode)}`, {
        credentials: 'same-origin',
    });

    if (!response.ok) {
        throw new Error('Partner logos could not be loaded.');
    }

    return response.json();
}

export default function PartnerLogoStrip({
    mode = 'dark',
    title = 'Proudly Supported By',
    className = '',
    compact = false,
}) {
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        let alive = true;

        fetchPartners(mode)
            .then((data) => {
                if (!alive) return;
                setPartners(Array.isArray(data?.partners) ? data.partners : []);
            })
            .catch(() => {
                if (alive) setPartners([]);
            });

        return () => {
            alive = false;
        };
    }, [mode]);

    if (!partners.length) return null;

    return (
        <section className={`bjnt-partner-strip bjnt-partner-strip--${mode}${compact ? ' bjnt-partner-strip--compact' : ''} ${className}`.trim()}>
            {title ? <h2>{title}</h2> : null}

            <div className="bjnt-partner-strip__logos" aria-label="Partners and sponsors">
                {partners.map((partner) => {
                    const name = decodeText(partner.name || 'Partner');
                    const scale = Math.max(60, Math.min(160, Number(partner.scale || 100)));
                    const logo = partner.logoUrl || (mode === 'light' ? partner.logoLightUrl : partner.logoDarkUrl);
                    const href = partner.websiteUrl || partner.instagramUrl || '';

                    const logoNode = (
                        <img
                            src={logo}
                            alt={name}
                            loading="lazy"
                            style={{ '--partner-logo-scale': scale / 100 }}
                        />
                    );

                    return (
                        <div className="bjnt-partner-strip__item" key={partner.id} title={name}>
                            {href ? (
                                <a href={href} target="_blank" rel="noreferrer" aria-label={name}>
                                    {logoNode}
                                </a>
                            ) : logoNode}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
